import React, { useEffect, useRef, useState } from "react";
import { CameraActiveIcon, CameraGreyIcon, CancelIcon, ComposerAttachmentIcon, ComposerSmileIcon, EmojiActiveIcon, FalconLogo, FalkonSmsLogoIcon, FileActiveIcon, HidePassword, LoginBgMobile, LoginBgTop, MediaDefaultIcon, MediaTxtIcon, MuteIcon, PdfIcon, RotateCameraIcon, SendWhiteIcon, SettingsVertiMobileIcon, ShowPassword, UnMuteIcon, UploadSuccessIcon, WordIcon, XlsIcon, ZipIcon } from "../../icon";
import Avatar from "../shared/avatar.component";
import MentionComponent from "../shared/mentions";
import CustomTooltip from "../conversations/CustomTooltip ";
import { Popover } from "@mui/material";
import Emojis from "../conversations/emojis";
import setToast from "../../helpers/toaster.helper";
import { appNote, ToasterTexts } from "../shared/constants";
import { ToasterType } from "../shared/toaster/toaster.model";
import Config from "../../config";
import { MediaFileType, MediaType } from "../../models/media.models";
import ImageComponent from "../shared/media/image.component";
import Video from "../shared/media/video.component";
import { UtilityService } from "../../services/UtilityService";
import { useDispatch, useSelector } from "react-redux";
import * as selector from '../../selectors/selectors';
import AudioComponent from "../shared/media/audio.component";
import ButtonComponent from "../shared/button/button.component";
import { SecureChatService } from "../../services/SecureChatService";
import { useLocation } from "react-router";
import { ConversationCardModel, DeliveryStatus, mapSecureChatParticipantToConversationCardModel, MediaModel } from "../../models/conversations";
import { updateHistory } from "../../reducers/reducer";
import ConnectWebSocket from "./web-socket";
import ConversationHistoryPage from "../conversations/conversation-history-page";
import store from "../../stores/app-store";
import AnimateLoaderComponent from "../shared/loaders/animate-loader.component";
import SecureChatMediaUploading from "../shared/loaders/secure-chat-media-uploading.json";
import ReactCodeInput from 'react-code-input';
import BadgeNotif from "../shared/badge-notif";
import { MenuItemRender } from "../shared/menu-item-render";
import { HmacSignatureUtilities } from "../../services/hmac-encryption-decryption";


enum SecureChatLoginStatus {
    EnterOtp = 0,
    SetPin,
    PinUpdateSuccess,
    EnterPin,
    Exceded_Retries,
    LoggedIn
}

const FalkonSecureChat: React.FC = () => {

    const location = useLocation();
    const params = new URLSearchParams(location.search)
    const participantId = params.get("id")

    const dispatch = useDispatch();

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const DeviceHeight: number = useSelector(selector.deviceHeight);

    const History = useSelector(selector.history);
    const FalkonWebSocket = useSelector(selector.falkonWebSocket)

    const [message, setMessage] = useState<string>("")
    const [participantData, setParticipantData] = useState<ConversationCardModel | any>()

    const [emojiHovering, setEmojiHovering] = useState<boolean>(false);
    const [fileHovering, setFileHovering] = useState<boolean>(false);
    const [cameraHovering, setCameraHovering] = useState<boolean>(false);
    const [emoji, setEmoji] = useState("");
    const [emojiAnchor, setEmojiAnchor] = useState(null)
    const [attachFileAnchor, setAttachFileAnchor] = useState(null)

    const [mediaUploading, setMediaUploading] = useState<{ Name: string, Status: boolean }>({ Name: "", Status: false });

    const emojiRef = useRef();
    const attachFileRef = useRef();
    const scrollRef = useRef<HTMLDivElement>();

    const [otp, setOtp] = useState<{ value: string, show: boolean, error: string }>({ value: "", show: false, error: "" });
    const [temporaryKey, setTemporaryKey] = useState<string>("");
    const [pin, setPin] = useState<{ value: string, show: boolean, error: string }>({ value: "", show: false, error: "" });
    const [confirmPin, setConfirmPin] = useState<{ value: string, show: boolean, error: string }>({ value: "", show: false, error: "" });

    const [loginStatus, setLoginStatus] = useState<number>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [timer, setTimer] = useState(0);
    const [canResend, setCanResend] = useState(false);

    const [audioUrl, setAudioUrl] = useState<any>("")
    const [audio, setAudio] = useState(new Audio(audioUrl));
    const [isFirstRender, setIsFirstRender] = useState(true);
    const [soundsOn, setSoundsOn] = useState<boolean>(true);
    const [business, setBusinessName] = useState<string>("")

    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [streamStarted, setStreamStarted] = useState(false);
    const [source, setSource] = useState(null); // 'camera' or 'upload'
    const [cam, setCam] = useState<"user" | "environment">("user"); // 'camera' or 'upload'

    const [capturedBlob, setCapturedBlob] = useState<Blob | null>(null);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const [files, setFiles] = useState<{ file: any, size: number, media: MediaModel }[]>([])

    useEffect(() => {
        if (source === 'camera' && !streamStarted) {
            startCamera("user");
        }

        return () => {
            if (videoRef.current?.srcObject) {
                videoRef.current.srcObject.getTracks().forEach(track => track.stop());
            }
        };
    }, [source]);

    const startCamera = async (facing: 'user' | 'environment', toggle?: boolean) => {
        if (toggle) {
            stopCamera();
        }
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: facing }, audio: false });
            setCam(facing)
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
                setStreamStarted(true);
            }
        } catch (err) {
            if (err.name === 'NotAllowedError') {
                alert("You denied camera permission. Please enable it in browser settings.");
            } else {
                alert("Could not access camera: " + err.message);
            }
        }
    };

    const stopCamera = () => {
        const stream = videoRef.current?.srcObject as MediaStream;
        if (stream) {
            stream.getTracks().forEach((track) => track.stop());
        }
        videoRef.current!.srcObject = null;
        setStreamStarted(false);
    };

    const toggleCamera = (facing) => {
        const nextFacing = facing === "user" ? 'environment' : 'user';
        setCam(nextFacing);
        startCamera(nextFacing);
    };

    const capturePhoto = async () => {
        if (!videoRef.current || !canvasRef.current) return;

        const video = videoRef.current;
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');
        if (!context) return;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        canvas.toBlob((blob) => {
            if (blob) {
                setCapturedBlob(blob);
                setPreviewUrl(URL.createObjectURL(blob)); // Show preview
            }
        }, 'image/jpeg', 0.9);
        stopCamera();
    };

    const handleRetake = () => {
        setCapturedBlob(null);
        setPreviewUrl(null);
        startCamera(cam);
    };

    const handleSend = async () => {
        if (!capturedBlob) return;
        const file = new File([capturedBlob], `falkon_img_${Date.now()}_${Math.random().toString(36).slice(2, 6)}.jpeg`, { type: 'image/jpeg' });
        const url = await toBase64(file)
        setMediaUploading({ Name: file.name, Status: true })

        const msgData = {
            type: "message",
            sender_id: participantData.PhoneNumber,
            recipient_id: participantData.SenderID,
            text: message,
            is_inbound: true,
            media_payload: [{
                value: url.split(",")[1],
                file_name: file.name,
                file_type: file.type,
            }]
        }

        try {
            FalkonWebSocket.send(JSON.stringify(msgData));
        } catch {
            setMediaUploading({ Name: "", Status: false });
        }
    };

    const optionData =
        [
            {
                Name: soundsOn ? "Sounds Off" : "Sounds On",
                Icon: soundsOn ? MuteIcon : UnMuteIcon,
                OnClick: () => { HandleSounds(!soundsOn) },
            },
        ]

    const HandleSounds = (sounds) => {
        setSoundsOn(sounds)
        SecureChatService.HandleNotificationSounds(participantId, { soundStatus: sounds }).then((res) => {

        }).catch((err) => {

        })
    }

    useEffect(() => {
        if (mediaUploading.Status) {
            if (History[participantId].find(x => x.Media[0]?.Name === mediaUploading.Name)) {
            setMediaUploading({ Name: "", Status: false });
            setFiles([])
            setCapturedBlob(null);
            setPreviewUrl(null);
            setSource(null);
        }
        }
    }, [History[participantId]])

    const reconnectWebSocket = () => {
        let ConnectedSocket = store.getState().FalkonWebSocket;

        // Ensure only reconnect when necessary
        if (document.visibilityState === "visible" && !!participantData?.PhoneNumber && (!ConnectedSocket || ConnectedSocket.readyState === WebSocket.CLOSED)
        ) {
            console.log("Reconnecting WebSocket...");
            ConnectWebSocket(dispatch, `wss://${(Config.API_SECOND_URL).replace("https://", "")}/falkon/notify/api/v1/websocket/connect?userId=${participantData.PhoneNumber}&falkonId=${participantData.FromPhoneNumber}`);
        }

        if (document.visibilityState === "visible") {
            const key = localStorage.getItem(participantId);
            const expiry = key ? parseInt(key, 10) : 0;
            if (!expiry || Date.now() > expiry) {
                handleLogOut();
            }
        }
    };

    useEffect(() => {
        if (!!participantData?.PhoneNumber) {
            let webSocket = store.getState().FalkonWebSocket;

            // Establish connection only if no active WebSocket exists
            if (!webSocket || webSocket.readyState === WebSocket.CLOSED) {
                console.log("Establishing initial WebSocket connection...");
                ConnectWebSocket(dispatch, `wss://${(Config.API_SECOND_URL).replace("https://", "")}/falkon/notify/api/v1/websocket/connect?userId=${participantData.PhoneNumber}&falkonId=${participantData.FromPhoneNumber}`);
            }

            // Attach event listeners only once
            window.addEventListener("visibilitychange", reconnectWebSocket);
            window.addEventListener("online", reconnectWebSocket);
        }

        return () => {
            // Always remove event listeners
            window.removeEventListener("visibilitychange", reconnectWebSocket);
            window.removeEventListener("online", reconnectWebSocket);
        };
    }, [participantData?.PhoneNumber]);


    const handleEmojiSelect = (e: any) => {
        setEmoji(e.native)
        setTimeout(() => {
            setEmoji("")
        }, 100)
        setEmojiAnchor(null)
    };

    const toBase64 = (file: any) => new Promise<any>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    const closeMedia = (index?: number) => {
        if (index >= 0) {
            let filterfiles = files.filter((_, i) => i !== index)
            setFiles(filterfiles);
        }
    }

    const handleMediaChange = async (e: any) => {
        let file = (e?.target?.files[0] || e);
        const Files = (e.target?.files || e);
        if (file?.type === "text/plain") {
            setToast(ToasterTexts.Text_File_Not_Supported, ToasterType.DANGER);
            closeMedia();
        }
        else {
            if (files?.length > 7) {
                setToast("Maximum 8 files allowed per message.", ToasterType.DANGER);
                return
            }
            if (Files && Files?.length > 0) {
                let statefiles = files;
                let newFiles = []
                newFiles = await Promise.all(Array.from(Files).map(async (file: File) => ({
                    file,
                    size: file?.size,
                    media: {
                        ID: "",
                        Name: file.name,
                        Url: await toBase64(file),
                        ContentType: file.type.split('/')[0]
                    }
                })));

                const savedFiles = [...statefiles, ...newFiles]
                if (savedFiles.reduce((sum, item) => sum + (item.size || 0), 0) > Config.SECURE_CHAT_FILE_SIZE) {
                    setToast(ToasterTexts.FILE_SIZE_EXCEED_LIMIT.replace("<size>", "10"), ToasterType.DANGER);
                    if (e.target) { e.target.value = "" }
                    return;
                }
                setFiles(savedFiles)
            };
        }
    }

    const getMediaComponent = (type: any, file: MediaModel) => {
        if (type != null) {
            switch (type) {
                case MediaType.IMAGE:
                case MediaType.IMAGE_GIF:
                case MediaType.IMAGE_JPEG:
                case MediaType.IMAGE_ARW:
                case MediaType.IMAGE_PNG:
                case MediaType.IMAGE_WEBP:
                case MediaType.IMAGE_SVG:
                    return <ImageComponent MediaUrl={file.Url} classname={"w-4 h-4"} text={true} />
                case MediaType.VIDEO:
                    return <Video MediaUrl={file.Url} controls={IsMobileDevice ? UtilityService.isIPhone(navigator.userAgent) : false} />
                case MediaType.AUDIO:
                case MediaType.AUDIO_MP3:
                case MediaType.AUDIO_MPeg:
                    return <AudioComponent MediaUrl={file.Url} controls={true} />
                case MediaFileType.PDF:
                    return <PdfIcon />
                case MediaFileType.ZIP:
                    return <ZipIcon />
                case MediaFileType.DOC:
                    return <WordIcon />
                case MediaFileType.DOCX:
                    return <WordIcon />
                case MediaFileType.XLSX:
                    return <XlsIcon />
                case MediaFileType.TXT:
                    return <MediaTxtIcon />
                default:
                    return <MediaDefaultIcon />
            }
        }
    }

    const getparticipantData = () => {
        SecureChatService.getPartcipantData(participantId).then(
            res => {
                if (HmacSignatureUtilities.verifySignature(res.data, res.headers["falkonsignature"])) {
                    setParticipantData(mapSecureChatParticipantToConversationCardModel(res.data))
                    setSoundsOn(res.data.sound_enabled)
                    setBusinessName(res.data.organization_name)
                }
                else {
                    setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
                }
            }
        )
    }

    useEffect(() => {
        if (!participantData && loginStatus === SecureChatLoginStatus.LoggedIn) {
            getparticipantData();
        }
    }, [loginStatus])

    const handleMessage = () => {
        const time = Date.now() + (10 * 60 * 1000)
        localStorage.setItem(participantId, time.toString())
        if (!!message || files?.length) {
            const msgData = {
                type: "message",
                sender_id: participantData.PhoneNumber,
                recipient_id: participantData.SenderID,
                text: message,
                is_inbound: true,
                media_payload: files.map(file => ({
                    value: file.media?.Url.split(",")[1],
                    file_name: file.media.Name,
                    file_type: (file.file as any).type,
                }))
                // },
            };
            if (!!files.length) {
                setMediaUploading({ Name: files[0]?.media?.Name, Status: true })
            }
            try {
                FalkonWebSocket.send(JSON.stringify(msgData))
                setMessage("");
            } catch {
                setMediaUploading({ Name: "", Status: false });
            }
        } else {
            alert("Enter a message and ensure you're connected!");
        }
    };

    const sendMMSMessage = () => {
        if (!!files.length) {
            setMediaUploading({ Name: files[0]?.media?.Name, Status: true })
            const mediaData = {
                type: "mms_message",
                mms_message: {
                    sender_id: participantData.PhoneNumber,
                    recipient_id: participantData.SenderID,
                    media_payload: files.map(file => ({
                        value: file.media?.Url.split(",")[1],
                        file_name: file.media.Name,
                        file_type: (file.file as any).type,
                    })),
                    is_inbound: true,
                },
            };

            FalkonWebSocket.send(JSON.stringify(mediaData));
        } else {
            alert("Select a file and ensure you're connected!");
        }
    };

    const onKeyChange = (event: any) => {
        if (!event?.shiftKey && (event?.keyCode === 13 || event.key === "Enter")) {
            handleMessage()
            event.preventDefault();
            return
        }
    }

    useEffect(() => {
        UtilityService.convertUrlToBlob("https://s3.us-central-1.wasabisys.com/falkonsecuredfilesdev/Secure_Chat/Live-chat-notify-sound").then(
            res => setAudioUrl(res)
        )
    }, [])

    useEffect(() => {
        setAudio(new Audio(audioUrl))
    }, [audioUrl])

    useEffect(() => {
        if (History[participantId]?.length && isFirstRender) {
            setIsFirstRender(false);
        }
        else {
            if (History[participantId]?.length && soundsOn) {
                audio.play();
            }
        }
    }, [History[participantId]?.filter(x => x.IsOutbound).length])

    useEffect(() => {
        const key = localStorage.getItem(participantId);
        const expiry = key ? parseInt(key, 10) : 0;
        if (!key) {
            SecureChatService.getSecureChatLoginStatus(participantId).then((res) => {
                if (HmacSignatureUtilities.verifySignature(res.data, res.headers["falkonsignature"])) {
                    if (res.data.attempts >= 5) {
                        setLoginStatus(SecureChatLoginStatus.Exceded_Retries)
                    }
                    if (res.data.method === "otp") {
                        setLoginStatus(SecureChatLoginStatus.EnterOtp)
                    }
                    if (res.data.method === "pin") {
                        if (expiry && Date.now() < expiry) {
                            setLoginStatus(SecureChatLoginStatus.LoggedIn)
                        }
                        else {
                            handleLogOut()
                        }
                    }
                }
                else {
                    setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
                }
            }).catch(() => {

            })
        }
        else {
            if (expiry && Date.now() < expiry) {
                setLoginStatus(SecureChatLoginStatus.LoggedIn)
            }
            else {
                handleLogOut()
            }
        }
    }, [participantId])

    useEffect(() => {
        const saved = localStorage.getItem(`${participantId}-resendCountDown`);
        if (saved) {
            const elapsed = Math.floor((Date.now() - Number(saved)) / 1000);
            const timeLeft = 120 - elapsed;
            if (timeLeft > 0) {
                setTimer(timeLeft);
                setCanResend(false);
            } else {
                setTimer(0);
                setCanResend(true);
            }
        } else {
            setCanResend(true);
        }
    }, [participantId]);

    useEffect(() => {
        if (timer <= 0) return;

        const interval = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    setCanResend(true);
                    localStorage.removeItem(`${participantId}-resendCountDown`)
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [timer]);

    useEffect(() => {

        const resendTime = localStorage.getItem(`${participantId}-resendCountDown`);
        const elapsed = resendTime ? Math.floor((Date.now() - Number(resendTime)) / 1000) : 120;

        if (loginStatus === SecureChatLoginStatus.EnterOtp && elapsed >= 120) {
            SendOtp()
        }

    }, [loginStatus])

    const SendOtp = () => {
        SecureChatService.SendSecureChatOtp(participantId).then((res) => {
            setToast(res.data.message, ToasterType.SUCCESS)
            localStorage.setItem(`${participantId}-resendCountDown`, Date.now().toString())
            setTimer(120);
            setCanResend(false);
        }).catch(() => {

        })
    }

    const handlePinChange = (value: string, Pin: boolean, Status: number) => {

        const match = value.length === 6 && (Pin ? confirmPin.value.length === 6 : pin.value.length === 6)

        if (Status === SecureChatLoginStatus.SetPin) {
            if (Pin ? value === confirmPin.value : value === pin.value) {
                setPin({ ...pin, value: Pin ? value : pin.value, error: "" })
                setConfirmPin({ ...confirmPin, value: Pin ? confirmPin.value : value, error: "" })
            }
            else {
                setPin({ ...pin, value: Pin ? value : pin.value, error: match ? "Pin do not match" : "" })
                setConfirmPin({ ...confirmPin, value: Pin ? confirmPin.value : value, error: match ? "Confirm Pin do not match" : "" })
            }
        }
        if (Status === SecureChatLoginStatus.EnterPin) {
            setPin({ ...pin, value: value, error: "" })
        }
        if (Status === SecureChatLoginStatus.EnterOtp) {
            setOtp({ ...otp, value: value, error: "" })
        }
    }

    const handleVerification = () => {
        setIsLoading(true)
        SecureChatService.VerifySecureChatOtp(participantId, { code: otp.value }).then((res) => {
            if (HmacSignatureUtilities.verifySignature(res.data, res.headers["falkonsignature"])) {
                if (!!res.data.Key) {
                    setTemporaryKey(res.data.Key)
                    setPin({ value: "", show: false, error: "" })
                    setConfirmPin({ value: "", show: false, error: "" })
                    setOtp({ value: "", show: false, error: "" })
                    setLoginStatus(SecureChatLoginStatus.SetPin)
                    setIsLoading(false)
                }
                else {
                    setToast(res.data.message, ToasterType.DANGER)
                    setOtp({ ...otp, error: res.data.message })
                    setIsLoading(false)
                }
            }
            else {
                if (!res.data.Key) {
                    setToast(res.data.message, ToasterType.DANGER)
                    setOtp({ ...otp, error: res.data.message })
                    setIsLoading(false)
                }
                else {
                    setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
                }
            }
        })
    }

    const handlePinSetUp = () => {
        setIsLoading(true)
        if (pin.value === confirmPin.value) {
            SecureChatService.SetSecureChatPin(participantId, { pin: pin.value, temporaryKey: temporaryKey }).then((res) => {
                setPin({ value: "", show: false, error: "" })
                setConfirmPin({ value: "", show: false, error: "" })
                setOtp({ value: "", show: false, error: "" })
                setLoginStatus(SecureChatLoginStatus.PinUpdateSuccess)
                setIsLoading(false)
            }).catch(() => {
                setPin({ value: "", show: false, error: "" })
                setConfirmPin({ value: "", show: false, error: "" })
                setOtp({ value: "", show: false, error: "" })
                setIsLoading(false)
            })
        }
        else {

        }
    }

    const handleLogin = () => {
        setIsLoading(true)
        SecureChatService.LoginSecureChat({ participantId: participantId, pin: pin.value }).then((res) => {
            if (HmacSignatureUtilities.verifySignature(res.data, res.headers["falkonsignature"])) {
                const time = Date.now() + (10 * 60 * 1000)
                localStorage.setItem(participantId, time.toString())
                localStorage.setItem(`${participantId}-accessToken`, res.data.access_token)
                localStorage.setItem(`${participantId}-refreshToken`, res.data.refresh_token)
                localStorage.setItem(`${participantId}-expiresIn`, res.data.expires_in)
                localStorage.removeItem(`${participantId}-resendCountDown`);
                setLoginStatus(SecureChatLoginStatus.LoggedIn)
                setIsLoading(false)
                setPin({ value: "", show: false, error: "" })
            }
            else {
                setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
            }
        }).catch((err) => {
            setIsLoading(false)
            setPin({ ...pin, error: err.response?.data.error })
            if (err.response?.data.attempts >= 5) {
                setLoginStatus(SecureChatLoginStatus.Exceded_Retries)
            }
        })
    }

    const handleLogOut = () => {
        setLoginStatus(SecureChatLoginStatus.EnterPin)
        localStorage.removeItem(participantId)
        localStorage.removeItem(`${participantId}-accessToken`)
        localStorage.removeItem(`${participantId}-refreshToken`)
        localStorage.removeItem(`${participantId}-expiresIn`)

        updateHistory({ phoneNumber: participantId, history: [] })
        setParticipantData(null)
        if (FalkonWebSocket) {
            FalkonWebSocket.close(4001, "Manual disconnect by user")
        }
    }


    return (
        <div className={`w-p-100 ${IsMobileDevice ? "h-v-90" : "h-v-100"} d-flex flex-direction justify-between align-center`}>
            <div className="hide-element">

                <BadgeNotif count={History[participantId]?.filter(x => x.IsOutbound).filter(x => x.DeliveryStatus === DeliveryStatus.RECEIVED).length} />

            </div>

            {!IsMobileDevice && <div className="login-rounded-top w-p-36" style={{ zIndex: -1 }}>
                <LoginBgTop />
            </div>}
            {!IsMobileDevice &&
                <div className="login-rounded-bottom w-p-36" style={{ zIndex: -1 }}>
                    <LoginBgMobile />
                </div>
            }
            {
                !IsMobileDevice && <div className={`d-flex justify-center align-center h-p-8`}>
                    <FalconLogo className={`w-20`} />
                </div>
            }
            {loginStatus === SecureChatLoginStatus.LoggedIn ?
                <>
                    <div className={`${IsMobileDevice ? "w-p-100 h-p-100" : "w-p-70 min-w-100 h-p-80 br-4"} bg-color-secondary max-w-160 secure-chat-box d-flex flex-direction`}>
                        <div className="w-p-100 h-10 d-flex align-center bb-primary-divider-4">
                            <Avatar Name={""} className="mx-2" Size={36} />
                            <div className="d-flex flex-direction justify-center">
                                <div className="h2-medium">
                                    {participantData && UtilityService.maskPhoneNumber(participantData.FromPhoneNumber)}
                                </div>
                                <div className="h5-medium">
                                    {IsMobileDevice ? business.slice(0, 24) : business}
                                </div>
                            </div>
                            <div className="d-flex align-center ml-auto mr-2">
                                <MenuItemRender MenuData={optionData} HorizantelIcon={true} MeetBallIcon={SettingsVertiMobileIcon} />
                            </div>
                        </div>
                        {participantData &&
                            <ConversationHistoryPage
                                activeCardIndex={0}
                                IsMobileDevice={IsMobileDevice}
                                pathName={location.pathname}
                                DeviceHeight={DeviceHeight}
                                scrollRef={scrollRef}
                                CardData={participantData}
                                OpenForwardMessage={() => { }}
                                UnreadCount={participantData.UnReadCount}
                                onEditScheduleChange={() => { }}
                                IsSecureChat={true}
                            />
                        }
                        <div className={`m-2 min-h-15 d-flex flex-direction RichEditor-root-border br-4`}>
                            <div className="w-p-100 h-5 d-flex align-center pl-1">
                                {!IsMobileDevice && <CustomTooltip title='Emoji' placement='bottom'>
                                    <div className="my-auto">
                                        <button tabIndex={13} data-up-arrow-index={300} ref={emojiRef}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (emojiAnchor) {
                                                    setEmojiAnchor(null)

                                                } else {
                                                    setEmojiAnchor(emojiRef.current)
                                                }
                                            }}
                                            onMouseEnter={() => { setEmojiHovering(true) }}
                                            onMouseLeave={() => { setEmojiHovering(false) }}
                                        >
                                            {(emojiHovering || !!emojiAnchor) ? <EmojiActiveIcon className={`c-pointer p-1`} /> : <ComposerSmileIcon className={`c-pointer p-1`} />
                                            }
                                        </button>
                                    </div>
                                </CustomTooltip >
                                }
                                {!mediaUploading.Status && <CustomTooltip title='Attach File' placement='bottom'>
                                    <div className="my-auto" ref={attachFileRef}>
                                        <label onKeyDown={(e) => { if (e.key === "Enter") { e.currentTarget?.click() } }} role="button" data-up-arrow-index={300} tabIndex={14} onClick={(e) => { setAttachFileAnchor(e.currentTarget) }} htmlFor={"icon-button-file"}
                                            onMouseEnter={() => { setFileHovering(true) }}
                                            onMouseLeave={() => { setFileHovering(false) }}
                                        >
                                            {fileHovering ? <FileActiveIcon className={`c-pointer p-1`} /> : <ComposerAttachmentIcon className={`c-pointer p-1`} />}
                                        </label>
                                        <input className={"d-none"} id={"icon-button-file"} onChange={handleMediaChange} accept="audio/*,video/*,image/*,.pdf,.doc,.docx,.xlsx,.zip,.txt" multiple type="file" />
                                    </div>
                                </CustomTooltip>
                                }
                                {!mediaUploading.Status && <CustomTooltip title='Open Camera' placement='bottom'>
                                    <div className="my-auto">
                                        <label role="button" data-up-arrow-index={300} tabIndex={15} onClick={() => { setSource('camera'); }}
                                            onMouseEnter={() => { setCameraHovering(true) }}
                                            onMouseLeave={() => { setCameraHovering(false) }}
                                        >
                                            {cameraHovering ? <CameraActiveIcon className={`c-pointer p-1`} /> : <CameraGreyIcon className={`c-pointer p-1`} />}
                                        </label>
                                    </div>
                                </CustomTooltip>
                                }
                            </div>
                            <div className="min-h-10 max-h-16 border-top px-2 py-1 h4-regular d-flex" onKeyDown={onKeyChange}>
                                <div className=" o-y-scroll h-p-100 w-p-100">
                                    <MentionComponent
                                        body={message}
                                        emoji={emoji}
                                        openTags={false}
                                        tagTarget={undefined}
                                        onChange={(e) => { setMessage(e.target.value) }}
                                        onKeyDown={() => { }}
                                        closeTags={() => { }}
                                        tags={[]}
                                        maxLength={0}
                                        id={""}
                                        placeholder={"Write a message..."}
                                    />
                                    {!!files?.length &&
                                        <div className={`d-flex flex-direction ${(IsMobileDevice ? "w-p-72 min-h-4 h-4 pt-1" : "min-h-6 h-6 pt-1 pb-1")} `}>
                                            {files.map((x, index) => (
                                                <div className="h-p-100 d-flex flex-direction justify-center br-2 mr-auto upload-media p-relative mb-1">
                                                    <div className='h-p-100 d-flex align-center px-1'>
                                                        <div className="w-4 h-4 d-flex align-center justify-center br-4 o-hidden">
                                                            {getMediaComponent(x.media.ContentType, x.media)}
                                                        </div>
                                                        <div className={`d-flex align-center h5-medium px-1 w-space`}>
                                                            {!!x.media.Name && x.media.Name.slice(0, 40) + (x.media.Name.length > 40 ? "..." : "")}
                                                        </div>
                                                        <div className="d-flex justify-center align-center ">
                                                            {!mediaUploading.Status && <CancelIcon
                                                                className={"c-pointer ml-2 w-2"}
                                                                onClick={() => closeMedia(index)}
                                                            />
                                                            }
                                                        </div>
                                                    </div>
                                                    {mediaUploading.Status &&
                                                        <div className='p-absolute d-flex align-center h-1 mr-1'>
                                                            <AnimateLoaderComponent LoaderAnimation={SecureChatMediaUploading} className={"h-1 mt-2"} />
                                                        </div>
                                                    }
                                                </div>))
                                            }
                                        </div>
                                    }
                                </div>
                                <ButtonComponent ButtonLabel={""} Variant={!!(message || (!!files?.length && !mediaUploading.Status)) ? "primary-btn" : "disabled-btn"} ClassName="send-btn-circle d-flex justify-center align-center w-6 h-6 ml-2 my-auto" Icon={SendWhiteIcon} IconToolTip={appNote.MESSAGE_SEND_TOOL_TIP} OnClick={handleMessage} />
                            </div>
                        </div>
                        {IsMobileDevice &&
                            <div className={`w-p-100 h-6 d-flex justify-center align-center ${IsMobileDevice ? "h5-medium" : "bg-color-secure-chat-footer"} color-setup-btn-focus`}>
                                Secured by <FalconLogo className={`ml-1 w-16`} />
                            </div>
                        }
                    </div>
                </>
                :
                <div className={`${IsMobileDevice ? "w-p-100 h-p-100" : "w-p-100 h-p-92"} d-flex flex-direction`}>
                    {loginStatus === SecureChatLoginStatus.EnterOtp &&
                        <div className={`d-flex justify-center flex-direction align-center w-p-100 my-auto pb-8`}>
                            <div className="mx-auto h1-medium py-1">
                                Please Verify Your Identity
                            </div>
                            <div className="mx-auto h4-medium color-secure-chat-login-pin">
                                A one-time OTP has been sent to your
                            </div>
                            <div className="mx-auto h4-medium color-secure-chat-login-pin mb-2">
                                registered phone number
                            </div>
                            <div className="mx-auto d-flex">
                                <ReactCodeInput
                                    name={"EnterOtp"}
                                    value={otp.value}
                                    type={otp.show ? "number" : "password"}
                                    fields={6}
                                    inputMode="numeric"
                                    onChange={(value) => { handlePinChange(value, false, SecureChatLoginStatus.EnterOtp) }}
                                    inputStyle={{ border: "none", borderBottom: otp.error ? "2px solid red" : "2px solid #1450FF", margin: "10px", font: "normal normal 500 24px/36px silkamedium", color: otp.error ? "red" : "#7B7B7B", width: IsMobileDevice ? "16px" : "40px", height: "40px", textAlign: "center" }}
                                />
                                {!pin.show ?
                                    <ShowPassword className="m-auto c-pointer" onClick={() => { setOtp({ ...otp, show: !otp.show }) }} />
                                    :
                                    <HidePassword className="m-auto c-pointer" onClick={() => { setOtp({ ...otp, show: !otp.show }) }} />
                                }
                            </div>
                            {canResend ?
                                <div className={`mx-auto py-1 color-primary-light c-pointer h5-medium`} onClick={SendOtp}>
                                    Resend
                                </div>
                                :
                                <div className={`mx-auto py-1 color-primary-accent h5-medium`}>
                                    {`Resend in ${timer}`}
                                </div>
                            }
                            <ButtonComponent ButtonLabel={"Confirm"} Loading={isLoading} ClassName={`${IsMobileDevice ? "min-w-16" : "w-p-20"} w-p-20 h3-regular unauth-screen-button-gredient`} Variant={otp.value.length === 6 && !otp.error ? "primary-btn" : "disabled-btn"} OnClick={handleVerification} />
                        </div>
                    }
                    {loginStatus === SecureChatLoginStatus.SetPin &&
                        <div className={`d-flex justify-center flex-direction align-center w-p-100 my-auto pb-8`}>
                            <div className="mx-auto h4-medium color-secure-chat-login-pin">
                                Set a 6-digit PIN for secure access
                            </div>
                            <div className="mx-auto d-flex">
                                <ReactCodeInput
                                    autoFocus
                                    name={"initialPin"}
                                    value={pin.value}
                                    type={pin.show ? "number" : "password"}
                                    fields={6}
                                    inputMode="numeric"
                                    onChange={(value) => { handlePinChange(value, true, SecureChatLoginStatus.SetPin) }}
                                    inputStyle={{ border: "none", borderBottom: pin.error ? "2px solid red" : "2px solid #1450FF", margin: "10px", font: "normal normal 500 24px/36px silkamedium", color: pin.error ? "red" : "#7B7B7B", width: IsMobileDevice ? "16px" : "40px", height: "40px", textAlign: "center" }}
                                />
                                {!pin.show ?
                                    <ShowPassword className="m-auto c-pointer" onClick={() => { setPin({ ...pin, show: !pin.show }) }} />
                                    :
                                    <HidePassword className="m-auto c-pointer" onClick={() => { setPin({ ...pin, show: !pin.show }) }} />
                                }
                            </div>
                            <div className="mx-auto h4-medium color-secure-chat-login-pin mt-8">
                                Confirm your 6-digit PIN
                            </div>
                            <div className="mx-auto d-flex">
                                <ReactCodeInput
                                    autoFocus={false}
                                    name={"ConfirmPin"}
                                    value={confirmPin.value}
                                    type={confirmPin.show ? "number" : "password"}
                                    fields={6}
                                    inputMode="numeric"
                                    onChange={(value) => { handlePinChange(value, false, SecureChatLoginStatus.SetPin) }}
                                    inputStyle={{ border: "none", borderBottom: confirmPin.error ? "2px solid red" : "2px solid #1450FF", margin: "10px", font: "normal normal 500 24px/36px silkamedium", color: confirmPin.error ? "red" : "#7B7B7B", width: IsMobileDevice ? "16px" : "40px", height: "40px", textAlign: "center" }}
                                />
                                {!confirmPin.show ?
                                    <ShowPassword className="m-auto c-pointer" onClick={() => { setConfirmPin({ ...confirmPin, show: !confirmPin.show }) }} />
                                    :
                                    <HidePassword className="m-auto c-pointer" onClick={() => { setConfirmPin({ ...confirmPin, show: !confirmPin.show }) }} />
                                }
                            </div>
                            <div className="mx-auto h-3 h5-medium color-primary-danger d-flex align-center">
                                {confirmPin.error}
                            </div>
                            <ButtonComponent ButtonLabel={"Confirm"} Loading={isLoading} ClassName={`${IsMobileDevice ? "min-w-16" : "w-p-20"} h3-regular unauth-screen-button-gredient mt-2`} Variant={(pin.value.length === 6 && confirmPin.value.length === 6) && !confirmPin.error ? "primary-btn" : "disabled-btn"} OnClick={handlePinSetUp} />
                        </div>
                    }
                    {
                        loginStatus === SecureChatLoginStatus.PinUpdateSuccess &&
                        <div className={`d-flex justify-center flex-direction align-center w-p-100 my-auto pb-8`}>
                            <div className="mx-auto mb-2">
                                <UploadSuccessIcon />
                            </div>
                            <div className="mx-auto d-flex h2-medium">
                                Your PIN has been updated!
                            </div>
                            <div className="mx-auto d-flex h2-medium mb-2">
                                Use the new PIN for future logins.
                            </div>
                            <ButtonComponent ButtonLabel={"Back to Login"} Loading={isLoading} ClassName={`${IsMobileDevice ? "min-w-16" : "w-p-20"} h3-regular unauth-screen-button-gredient mt-2`} Variant={"primary-btn"} OnClick={() => { setLoginStatus(SecureChatLoginStatus.EnterPin) }} />
                        </div>
                    }
                    {loginStatus === SecureChatLoginStatus.EnterPin &&
                        <div className={`d-flex justify-center flex-direction align-center w-p-100 my-auto pb-8`}>
                            <div className="mx-auto h1-medium py-1">
                                Enter PIN
                            </div>
                            <div className="mx-auto h4-medium color-secure-chat-login-pin">
                                Enter your 6-digit PIN for secure access
                            </div>
                            <div className="mx-auto d-flex">
                                <ReactCodeInput
                                    name={"EnterPin"}
                                    value={pin.value}
                                    type={pin.show ? "number" : "password"}
                                    fields={6}
                                    inputMode="numeric"
                                    onChange={(value) => { handlePinChange(value, true, SecureChatLoginStatus.EnterPin) }}
                                    inputStyle={{ border: "none", borderBottom: pin.error ? "2px solid red" : "2px solid #1450FF", margin: "10px", font: "normal normal 500 24px/36px silkamedium", color: pin.error ? "red" : "#7B7B7B", width: IsMobileDevice ? "16px" : "40px", height: "40px", textAlign: "center" }}
                                />
                                {!pin.show ?
                                    <ShowPassword className="m-auto c-pointer" onClick={() => { setPin({ ...pin, show: !pin.show }) }} />
                                    :
                                    <HidePassword className="m-auto c-pointer" onClick={() => { setPin({ ...pin, show: !pin.show }) }} />
                                }
                            </div>
                            <div className="mx-auto h-3 h5-medium color-primary-danger d-flex align-center">
                                {pin.error}
                            </div>
                            <ButtonComponent ButtonLabel={"Login"} Loading={isLoading} ClassName={`${IsMobileDevice ? "min-w-16" : "w-p-20"} h3-regular unauth-screen-button-gredient mt-2`} Variant={pin.value.length === 6 && !pin.error ? "primary-btn" : "disabled-btn"} OnClick={handleLogin} />
                            <div className="mx-auto color-primary-light c-pointer h5-medium" onClick={() => { setLoginStatus(SecureChatLoginStatus.EnterOtp) }}>
                                Forgot Pin ?
                            </div>
                        </div>
                    }
                    {
                        loginStatus === SecureChatLoginStatus.Exceded_Retries &&
                        <div className={`d-flex flex-direction justify-center align-center w-p-100 h-p-100`}>
                            <div className="mx-auto h1-medium py-1 color-primary-danger">
                                You've Exceded invalid pin entries
                            </div>
                            <div className="mx-auto h4-medium color-primary-danger">
                                Please Reset Your Pin.
                            </div>
                            <ButtonComponent ButtonLabel={"Reset Pin"} Loading={isLoading} ClassName={`${IsMobileDevice ? "min-w-16" : "w-p-20"} h3-regular unauth-screen-button-gredient mt-2`} Variant={"primary-btn"} OnClick={() => { setLoginStatus(SecureChatLoginStatus.EnterOtp) }} />
                        </div>
                    }
                    {IsMobileDevice &&
                        <div className={`w-p-100 h-6 d-flex justify-center align-center mt-auto ${IsMobileDevice ? "h5-medium" : "bg-color-secure-chat-footer"} color-setup-btn-focus`}>
                            <FalkonSmsLogoIcon className="mr-1 w-4 h-4" /> Secured by Falkon SMS
                        </div>
                    }
                </div>

            }
            {!IsMobileDevice &&
                <div className={`w-p-100 h-p-8 h5-medium d-flex justify-center align-center ${IsMobileDevice ? "" : "bg-color-secure-chat-footer"} color-secure-file-email-filename`}>
                    <FalkonSmsLogoIcon className="mr-1 w-4 h-4" /> Secured by Falkon SMS
                </div>
            }
            {!!emojiAnchor &&
                <Popover
                    open={!!emojiAnchor}
                    anchorEl={emojiAnchor}
                    onClose={() => { setEmojiAnchor(null) }}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                >
                    <Emojis handleEmojiSelect={handleEmojiSelect} />
                </Popover>
            }

            {source === 'camera' && (
                capturedBlob
                    ?
                    <div className="w-p-100 h-p-100 m-auto p-absolute d-flex flex-direction align-center justify-center bg-color-greyish-transparent">
                        <div className="bg-color-secondary p-2 m-auto d-flex flex-direction">
                            <CancelIcon className="ml-auto mb-2 c-pointer" onClick={() => {
                                setSource(null); setCapturedBlob(null)
                            }} />
                            <img src={previewUrl} style={{ width: '100%', maxWidth: '400px' }} />
                            <div className="d-flex mx-auto">
                                <ButtonComponent ButtonLabel={"Retake"} Variant={"secondary-btn"} OnClick={handleRetake} ClassName="mr-2" />
                                <ButtonComponent ButtonLabel={"Send"} Variant={"primary-btn"} OnClick={handleSend} Loading={mediaUploading.Status} />
                            </div>
                        </div>
                    </div>
                    :
                    <div className="w-p-100 h-p-100 m-auto p-absolute d-flex flex-direction align-center justify-center bg-color-greyish-transparent">
                        <div className="bg-color-secondary p-2 m-auto d-flex flex-direction">
                            <div className="ml-auto mb-2">
                                {IsMobileDevice && <RotateCameraIcon className="c-pointer mr-2" onClick={() => { startCamera(cam === "user" ? "environment" : "user", true) }} />}
                                <CancelIcon className="c-pointer" onClick={() => { setSource(null); stopCamera(); }} />
                            </div>
                            <video ref={videoRef} autoPlay playsInline style={{ width: '100%', maxWidth: '400px' }} />
                            <ButtonComponent ButtonLabel={"Capture"} Variant={"primary-btn"} ClassName="mx-auto" OnClick={capturePhoto} />
                            <canvas ref={canvasRef} style={{ display: 'none' }} />
                        </div>
                    </div>
            )}
        </div >
    )
}

export default FalkonSecureChat;